module.exports = __webpack_public_path__ + "static/Metropolis-Light-628ba513f8c168059cabc54b9d5da363.woff";